import React from 'react';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true, helperText: 'e.g. "Flood", "Overhead" or "Trickle"' },
];

const IrrigationMethodManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Irrigation Methods"
    icon={<WaterDropIcon />}
    apiPath="/api/irrigation-methods"
    fields={fields}
    entityLabel="Irrigation Method"
  />
);

export default IrrigationMethodManagement;
